module.exports = __webpack_public_path__ + "static/media/dentistaEConsultorioOdontologico.b65f5b89.jpg";